<template>
  <v-app>
    <!-- <keep-alive> -->
    <component :is="getThemeMode.layout" />
    <!-- </keep-alive> -->
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {

  data() {
    return {
      layoutName: "",
    };
  },
  computed: {
    ...mapGetters(["getThemeMode"]),
  },
  methods: {
    ...mapActions(["changeThemeLayout"]),
  },
};
</script>
